<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <!--          <img v-if="onlyOneChild.meta.title === '药材管理' && datas !=='/medicine'" style="width: 14px;margin-right: 16px;margin-left: 19px" src="../../../../assets/icon/medi1.png" alt="">-->
          <!--          <img v-if="onlyOneChild.meta.title === '药材管理' && datas === '/medicine'" style="width: 14px;margin-right: 16px;margin-left: 19px" src="../../../../assets/icon/med-w.png" alt="">-->
          <!--          <img v-if="onlyOneChild.meta.title === '药材管理' && datas === '/medicine/index'" style="width: 14px;margin-right: 16px;margin-left: 19px" src="../../../assets/icon/repice1.png" alt="">-->
          <el-badge v-if="onlyOneChild.meta.title=='处方审核'" :value="recipeNum" :max="99" style="position: relative">
            <span style="margin-left: 49px;" >处方审核</span>
          </el-badge>
          <item v-else :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <!--        {{datas}}{{data1}}-->
        <!--        <span v-if="data1 === '/'">-->
        <!--          <img v-if="item.meta.title ===库存管理' && datas !== '/inventory'" style="width: 14px;margin-right: 16px" src="../../../assets/icon/inv3.png" alt="">-->
        <!--        <img v-if="item.meta.title ===  '库存管理' && datas === '/inventory'" style="width: 14px;margin-right: 16px" src="../../../assets/icon/inv2.png" alt="">-->
        <!--        <img v-if="item.meta.title === ''处方管理' && datas === '/recipe'" style="width: 14px;margin-right: 16px" src="../../../assets/icon/rep2.png" alt="">-->
        <!--        <img v-if="item.meta.title === '处方管理' && datas === '/recipe'" style="width: 14px;margin-right: 16px" src="../../../assets/icon/rep3.png" alt="">-->
        <!--        </span>-->
        <!--        <span v-if="data1 !== '/'">-->
        <img v-if="item.meta.title === '药材管理' && datas !=='/medicines'" style="width: 14px;margin-right: 16px;margin-left: 19px" src="../../../../assets/icon/medi1.png" alt="">
        <img v-if="item.meta.title === '药材管理' && datas === '/medicines'" style="width: 14px;margin-right: 16px;margin-left: 19px" src="../../../../assets/icon/med-w.png" alt="">
        <img v-if="item.meta.title === '库存管理' && datas === '/inventory'" style="width: 14px;margin-right: 16px;margin-left: 19px" src="../../../../assets/icon/inv-w.png" alt="">
        <img v-if="item.meta.title === '库存管理' && datas !== '/inventory'" style="width: 14px;margin-right: 16px;margin-left: 19px" src="../../../../assets/icon/inv3.png" alt="">
        <img v-if="item.meta.title === '处方管理' && datas === '/recipe'" style="width: 14px;margin-right: 16px;margin-left: 19px" src="../../../../assets/icon/rep-w.png" alt="">
        <img v-if="item.meta.title === '处方管理' && datas !== '/recipe'" style="width: 14px;margin-right: 16px;margin-left: 19px" src="../../../../assets/icon/rep3.png" alt="">
        <!--        </span>-->
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/common/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'
export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    checks: {
      type: String,
      default: ''
    },
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {
      checkItem: '',
      data1: ''
    }
  },
  computed:{
    datas(){
      if (!this.checks) {
        return  window.sessionStorage.getItem('menuItem')
      } else {
        return this.checks
      }
    },
    recipeNum(){
      return this.$store.getters.recipeNum * 1
    }
  },

  methods: {
    changeColor(){
      this.data1 = window.sessionStorage.getItem('menuColor')
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })
      // When there is only one child router, the child router is displayed by default
      // if (showingChildren.length === 1) {
      //   return true
      // }
      if (showingChildren.length === 1) {
        if(showingChildren[0].meta.title == '首页'){
          return true
        }else{
          return false
        }
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
<style scoped>
/deep/ .el-badge {
  position: relative !important;
}
/deep/ .el-badge__content {
  position: absolute !important;
  left: 50px !important;
  top: 10px !important;
}
</style>
